import Reflux from "reflux";

export default Reflux.createActions({
  updateSharingTextInputValue: { sync: true },
  submitShare: {},
  openShareModal: {},
});
